module.exports = __webpack_public_path__ + "img/ug3310.08ed795c.png";